// extracted by mini-css-extract-plugin
export default {"root":"oHa41A7_doja1ffUMNE_"};